import React from "react";
import classNames from "classnames";
import negativeIcon from "./assets/negative.svg";
import positiveIcon from "./assets/positive.svg";
import ChangeFormatted from "../../../../../../common/ChangeFormater";
import { compose } from "redux";
import withTranslations from "../../../../../../hocs/withTranslations";
import moment from "moment-mini";
import Price from "../../../../../../common/Price";
import useIsDesktop from "../../../../landingPage/hooks/useIsDesktop";
import ChangeAbstract from "../../../../../../abstract/ChangeAbstract";

const StockChange = ({
  change,
  changeValue,
  close,
  currency,
  locale,
  translate,
  latestQuoteDatetimeUtc
}) => {
  const isDesktop = useIsDesktop();

  const changeNum = change != null ? Number(change) : null;
  const isPositive = changeNum != null && changeNum > 0;
  const isNegative = changeNum != null && changeNum < 0;
  const hasChange = change != null;

  const quoteDateFormatted =
    latestQuoteDatetimeUtc && moment(latestQuoteDatetimeUtc).isValid()
      ? moment(latestQuoteDatetimeUtc).format("DD.MM.YYYY")
      : null;

  return (
    <div className={classNames("flex flex-col text-right align-end")}>
      {close != null && (
        <div
          className={classNames("line-height-130 font-bold text-black", {
            "text-3xl.1": isDesktop,
            "text-2xl": !isDesktop
          })}
        >
          <Price
            value={close}
            currency={currency}
            locale={locale}
            roundToSecondNumber
          />
        </div>
      )}
      {hasChange && (
        <div
          className={classNames(
            "text-sm line-height-100 font-bold flex items-center gap-1",
            {
              "text-red": isNegative,
              "text-green": isPositive,
              "text-black": !isPositive && !isNegative,
              "text-sm": isDesktop,
              "text-xs": !isDesktop
            }
          )}
        >
          {isNegative && (
            <img className="shrink-0" src={negativeIcon} alt="Down arrow" />
          )}
          {isPositive && (
            <img className="shrink-0" src={positiveIcon} alt="Up arrow" />
          )}
          <ChangeFormatted
            change={changeValue}
            unit={ChangeAbstract.UNIT_EMPTY}
          />{" "}
          (
          <ChangeFormatted change={change} />)
        </div>
      )}
      {quoteDateFormatted && (
        <div
          className={
            "line-height-130 font-normal text-black-9 mt-1.5 text-xs.1"
          }
        >
          {translate("Quote")}:{" "}
          <span className={"font-semibold"}>{quoteDateFormatted}</span>
        </div>
      )}
    </div>
  );
};

export default compose(withTranslations)(StockChange);
